module.exports = __webpack_public_path__ + "img/PF.2444f6c9.svg";